import { Injectable } from '@angular/core';
import {
    BuyerContactClient,
    CreateBuyerContactClientInput,
    DeleteBuyerContactClientInput,
    UpdateBuyerContactClientInput
} from '@app/core/services/api/API.service';
import { generateClient } from 'aws-amplify/api';
import * as mutations from '@graphql/mutations';
import * as queries from '@graphql/queries';

@Injectable({
    providedIn: 'root'
})
export class BuyerContactClientService {
    private amplifyClient = generateClient();

    constructor() {}

    async listAllBuyerContactsByCompanyId(
        companyId: string,
        pageLimit: number = 10
    ): Promise<BuyerContactClient[]> {
        const contacts: BuyerContactClient[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.BuyerContactsClientByCompanyId,
                        variables: {
                            companyId,
                            limit: pageLimit,
                            nextToken
                        }
                    })
                ).data.BuyerContactsClientByCompanyId;
                contacts.push(
                    ...((response?.items ?? []) as BuyerContactClient[])
                );
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);
            return contacts;
        } catch (error) {
            console.error('Error finding BuyerContactClient:', error);
            return [];
        }
    }

    async buyerContactsRfqByCompanyId(
        companyId: string
    ): Promise<BuyerContactClient[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.BuyerContactsClientByCompanyId,
                    variables: {
                        companyId
                    }
                })
            ).data.BuyerContactsClientByCompanyId.items;
            if (data) return data as BuyerContactClient[];
        } catch (error) {
            console.error('Error finding BuyerContactsRFQ:', error);
            return null;
        }
    }

    async createBuyerContactClient(
        input: CreateBuyerContactClientInput
    ): Promise<BuyerContactClient> {
        try {
            const buyerContactClient = (
                await this.amplifyClient.graphql({
                    query: mutations.createBuyerContactClient,
                    variables: {
                        input
                    }
                })
            ).data.createBuyerContactClient;
            if (buyerContactClient)
                return buyerContactClient as BuyerContactClient;
        } catch (error) {
            console.error('Error creating buyerContactClient:', error);
            return null;
        }
    }

    async updateBuyerContactClient(
        input: UpdateBuyerContactClientInput
    ): Promise<BuyerContactClient> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updateBuyerContactClient,
                    variables: {
                        input
                    }
                })
            ).data.updateBuyerContactClient as BuyerContactClient;
            if (data) return data;
        } catch (error) {
            console.error('Error updating BuyerContactClient:', error);
            return null;
        }
    }

    async deleteBuyerContactsRFQ(
        input: DeleteBuyerContactClientInput
    ): Promise<BuyerContactClient> {
        try {
            const deleteBuyer = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteBuyerContactClient,
                    variables: {
                        input
                    }
                })
            ).data.deleteBuyerContactClient;
            return deleteBuyer as BuyerContactClient;
        } catch {
            console.error('Error deleted BuyerContactClient:', Error);
            return null;
        }
    }
}
